import styled from "styled-components";

export const EmailAttachmentGroup = styled.div`
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fill, 186px);

    & > * {
        height: 48px;
    }
`;